import {useRecoilValue, useSetRecoilState} from "recoil";
import {
   cartState,
   deliveryInfoState,
   loadingPageState,
   orderState,
   showModalErrorOrderState,
   totalAmountState
} from "../../../state";
import {useSearchParams, useNavigate} from 'react-router-dom'
import {sendRequestAuth} from "../../../api/api";
import {CONFIG} from "../../../api/config";
import region from 'utils/_data.json'
import {transformAddressData} from "utils/transform";

export const useCartProduct = () => {

   const [searchParams] = useSearchParams()
   const orderId = searchParams.get('id') || ''
   const hashOrder = searchParams.get('hash') || ''
   const nav = useNavigate()
   const setCartOrder = useSetRecoilState(cartState)
   const setLoading = useSetRecoilState(loadingPageState)
   const loadingPage = useRecoilValue(loadingPageState)
   const setDeliveryInfoState = useSetRecoilState(deliveryInfoState)
   const setDisplayModalErrorOrder = useSetRecoilState(showModalErrorOrderState)
   // call API get order

   const getOrderDetail = async () => {
      const response = await sendRequestAuth('get', `${CONFIG.API}/order/detail/${orderId}?hash=${hashOrder}`)
      if (!!response.data?.success) {
         const order = response.data?.data
         if (+order?.is_social_confirm === 1) nav('/shopping/detail?id=' + orderId + '&hash=' + hashOrder)
         if (order?.order_details?.length > 0) {
            setCartOrder(order?.order_details)

            const province = region.find(item => item.id === order.city_id)
            const ward = province?.list.find(item => item.id === order.ward_id)
            const wardList = province?.list?.map(transformAddressData)
            setDeliveryInfoState(prev => ({
               phoneNumber: {...prev.phoneNumber, value: order.customer_mobile},
               receiverName: {...prev.receiverName, value: order.customer_name},
               address: {value: order.customer_address, validate: prev.address.validate},
               province: {...prev.province, value: {...province, value: province?.id}},
               ward: {
                  ...prev.ward,
                  value: {...ward, value: ward?.id},
                  list: wardList,
                  listOrigin: wardList
               },
               notes: order.note || ''
            }))
         } else nav('/')
      } else {
         nav('/')
      }
   }
   const deliveryInfomation = useRecoilValue(deliveryInfoState)
   const setDeliveryInfomation = useSetRecoilState(deliveryInfoState)
   const orderData = useRecoilValue(orderState)
   const cart = useRecoilValue(cartState)
   const totalAmount = useRecoilValue(totalAmountState)
   const {address, phoneNumber, province, receiverName, ward, notes} = deliveryInfomation

   const checkValidateAll = () => {
      setDeliveryInfomation({
         phoneNumber: {
            ...phoneNumber,
            validate: phoneNumber.value ? phoneNumber.validate : 'Số điện thoại không được để trống',
         },
         receiverName: {
            ...receiverName,
            validate: receiverName.value ? receiverName.validate : 'Tên người nhận không được để trống',
         },
         address: {
            ...address,
            validate: address.value ? address.validate : 'Địa chỉ không được để trống',
         },
         province: {
            ...province,
            validate: province.value?.value ? province.validate : 'Tỉnh/thành phố không được để trống',
         },
         ward: {
            ...ward,
            validate: ward.value?.value ? ward.validate : 'Phường/xã không được để trống',
         },
      })
   }

   const updateOrder = async () => {

      if (!!loadingPage) return

      checkValidateAll()
      const hasInvalidField = [
         !!address.validate,
         !!phoneNumber.validate,
         !!province.validate,
         !!receiverName.validate,
         !!ward.validate,
      ].includes(true)

      if (hasInvalidField) return

      setLoading(true)

      const data = {
         "customers": {
            customer_id: orderData?.customer_id || '',
            customer_mobile: phoneNumber.value || '',
            customer_name: receiverName.value || '',
            customer_address: address.value || '',
            city_id: province?.value?.value || '',
            ward_id: ward?.value?.value || '',
            is_two_levels: 1,
         },
         "item_details": cart,
         "total_amount": totalAmount,
         "note": notes,
         "is_conform_social": 1
      }

      const response = await sendRequestAuth('post', `${CONFIG.API}/order/update/${orderId}?hash=${hashOrder}`, data)

      if (response?.data?.success) {
         nav('/shopping/detail?id=' + orderId + '&hash=' + hashOrder + '&completed=true')
         setCartOrder([])
         setLoading(false)
      } else {

         setLoading(false)
      }

   }

   const updateProductOfOrder = async (newProduct) => {

      const newTotal = newProduct.reduce((total, item) => total + (+item.quantity * +item.price), 0);
      const data = {
         "item_details": newProduct,
         "total_amount": newTotal,
      }
      await sendRequestAuth('post', `${CONFIG.API}/order/update-product/${orderId}?hash=${hashOrder}`, data)

   }

   const deleteProductOfOrder = async (productId) => {
      const data = {
         "id": productId
      }
      await sendRequestAuth('delete', `${CONFIG.API}/order/delete-product/${orderId}?hash=${hashOrder}`, data)

   }
   return {
      func: {
         getOrderDetail,
         updateOrder,
         updateProductOfOrder,
         deleteProductOfOrder
      }
   }

}